import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    if (this.props.fallback) return this.props.fallback(this.state.error, this.reset);

    return (
      <div data-testid="error-boundary" className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-md w-full text-center border border-amber-900/40 bg-zinc-950/80 px-6 py-8 rounded-sm">
          <AlertTriangle className="mx-auto text-amber-400 mb-3" size={32} />
          <div className="font-cinzel text-amber-300 uppercase tracking-wide text-lg mb-2">Something went wrong</div>
          <p className="text-sm text-zinc-400 mb-4">
            The arena hit an unexpected error. Your progress is safe — reload to return to the action.
          </p>
          <p className="text-[11px] text-zinc-600 break-words mb-5">{String(this.state.error?.message || this.state.error)}</p>
          <button data-testid="error-boundary-reload" onClick={() => window.location.reload()}
            className="font-cinzel uppercase tracking-widest text-sm text-amber-300 border border-amber-700/60 hover:bg-amber-900/30 px-5 py-2 transition-colors">
            Reload
          </button>
        </div>
      </div>
    );
  }
}
